/**
 * Created by shubham on 27/4/18.
 */

import {Component, Input} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {HttpService} from '../shared/services/http.service'
import {MdDialog} from '@angular/material';
import {CommonService} from '../shared/services/common.service';
import {DialogComponent} from '../dialog/dialog.component';
import {DashboardActionDialogComponent} from '../dialog/dialog.component';

@Component({
    selector: 'approve-reject',
    template: require('./approve-reject.component.html')
})

export class ApproveRejectComponent {
    @Input() childData: any;
    @Input() dashboard: any;
    dialogRef;

    constructor(private router: Router, private route: ActivatedRoute, private httpService: HttpService,
                private dialog: MdDialog, private commonService: CommonService) {
    }

    public performAction(status) {
        this.dialogRef = this.dialog.open(DashboardActionDialogComponent);

        let actionStatus;
        if (status == 'approved') {
            actionStatus = 'APPROVE';
            this.dialogRef.componentInstance.msg = 'rqst_approve_confirm';
            this.dialogRef.componentInstance.isApproved = true;
        } else if (status == 'rejected') {
            actionStatus = 'REJECT';
            this.dialogRef.componentInstance.isReject = true;
            this.dialogRef.componentInstance.msg = 'rqst_rjct_confirm';
        }

        this.dialogRef.componentInstance.multiApproveRejectFlag = false;
        this.dialogRef.componentInstance.dashboard = this.dashboard;
        this.dialogRef.componentInstance.row = this.childData;
        this.dialogRef.afterClosed().subscribe(result => {
            if (result) {
                let data = {};
                data['id'] = this.childData.id;
                if (this.childData.Name) {
                    data['Name'] = this.childData.Name;
                } else {
                    data['Name'] = this.childData.firstName + ' ' + this.childData.lastName;
                }

                if (this.childData.email) {
                    data['email'] = this.childData.email;
                }

                if (this.childData.userId_WPASS) {
                    data['userId_WPASS'] = this.childData.userId_WPASS;
                }

                if (this.childData && this.childData.businessUnitId) {
                    data['businessUnitId'] = this.childData.businessUnitId;
                }

                if (status == 'approved') {
                    data['status'] = 'BU_APPROVE';
                    if (this.dashboard == 'admin' || this.dashboard == 'partnersView') {
                        //data['roleId'] = result.roleId;
                        data['customerNumber'] = result.customerNumber;
                        data['partnerType'] = result.selectedPartnerType;
                    }
                } else if (status == 'rejected') {
                    data['message'] = result;
                    data['status'] = 'BU_REJECT';
                }

                let today = new Date();
                let dd = ('0' + today.getDate()).slice(-2);
                let mm = ('0' + (today.getMonth() + 1)).slice(-2);
                let yyyy = today.getFullYear();
                data['approvalDate'] = yyyy + '' + mm + '' + dd;

                console.log(data);
                if (this.dashboard == 'admin' || this.dashboard == 'partnersView') {
                    if(data['userId_WPASS'] && data['userId_WPASS'] != ""){
                        this.httpService.postRequest(data, 'partnerOperationsApi/v1/approveRejectNewBusinessUnitForPartner').subscribe(
                            res => {
                                this.saveResponse(res, status, true);
                            },
                            err => {
                                this.httpService.onEnd();
                            }
                        );
                    } else {
                        this.httpService.postRequest(data, 'userRegistrationsApi/v1/approveBusinessUnit').subscribe(
                            res => {
                                this.saveResponse(res, status, false);
                            },
                            err => {
                                this.httpService.onEnd();
                            }
                        );
                    }

                } else if (this.dashboard == 'partners' || this.dashboard == 'subUsersView') {
                    this.httpService.postRequest(data, 'partnerOperationsApi/v1/approveCompanyUserCreationRequest').subscribe(
                        res => {
                            this.saveResponse(res, status, false);
                        },
                        err => {
                            this.httpService.onEnd();
                        }
                    );
                }
            }
            this.dialogRef = null;
        });
    }

    public saveResponse(res, status, wpassIdCreated) {
        this.httpService.onEnd();
        let statusTxt;
        console.log(wpassIdCreated);
        if (res) {
            if (status == 'approved') {
                if(wpassIdCreated){
                    statusTxt = 'after_new_bu_approval_notify';
                } else {
                    statusTxt = 'after_user_creation_approval_notify';
                }
            } else {
                statusTxt = 'Rejected Successfully';
            }
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = statusTxt;

            if (this.dashboard == 'admin') {
                this.commonService.changeAdminDashboardData();
            } else if (this.dashboard == 'partnersView') {
                this.commonService.changePartnerViewData();
            } else if (this.dashboard == 'partners') {
                this.commonService.changePartnersDashboardData();
            } else if (this.dashboard == 'subUsersView') {
                this.commonService.changeSubUserViewData();
            }
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/approve-reject-request/approve-reject.component.ts